// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","431":"component---src-pages-pinball-js","939":"a9ec3a24"}[chunkId] + "-" + {"293":"f1aecf85dc08f4f66e1a","431":"cb2a1375d8bb7d08843d","939":"0253b9617b0cb0055e25"}[chunkId] + ".js";
};